"use client"

import { ComponentConfig } from "@measured/puck"
import { RegistrationFormRenderProps, RenderConfig } from "./RenderConfig"

export const RegistrationForm: ComponentConfig<RegistrationFormRenderProps> = {
    label: "Tamda Foods | Registration Form",
    fields: {
        title: {
            label: "Title",
            type: "text",
        },
        description: {
            label: "Description",
            type: "textarea",
        },
        className: {
            label: "Class Name",
            type: "text",
        },
        linkTermsOfService: {
            label: "Link Terms of Service",
            type: "text",
        },
    },
    defaultProps: {
        title: "DÀNH CHO NHÀ CUNG CẤP",
        description: "Bạn có giao hàng cho các trung tâm bán buôn TDF không? Các thông tin sau đây được dành riêng cho bạn.",
        className: "",
        linkTermsOfService: "/services#terms",
    },
    ...RenderConfig,
}

